export default __webpack_public_path__ + "static/media/AdobeStock_4.70f15643.jpeg";